import { Transaction } from '../transactions/transaction';
import moment from 'moment/moment';
import { Moment } from 'moment';
import { LegFiJwtService } from '../../../services/auth/legfi-jwt.service';

export class AllianceTransaction
{
    transactionId: number;
    institutionNumber: number;
    accountNumber: number;
    transactionDate: Moment;
    postedDate: Moment;
    externalTransactionCode: number;
    transactionCodeType: string;
    transactionCodeDescription: string;
    isCheckTransaction: boolean;
    traceNumber: number;
    description: string;
    transactionAmount: number;
    checkNumber: number;
    transaction: Transaction;
    matchType: string;

    constructor(ref) {
        this.transactionId = ref.transactionID;
        this.institutionNumber = ref.institutionNumber;
        this.accountNumber = ref.accountNumber;

        if (ref.transactionDate) {
            this.transactionDate = ref.transactionDate;
        }
        if (ref.postedDate) {
            this.postedDate = ref.postedDate;
        }
        this.externalTransactionCode = ref.externalTransactionCode;
        this.transactionCodeType = ref.transactionCodeType;
        this.transactionCodeDescription = ref.transactionCodeDescription;
        this.isCheckTransaction = ref.isCheckTransaction;
        this.traceNumber = ref.traceNumber;
        this.description = ref.description;
        this.transactionAmount = ref.transactionAmount;
        this.checkNumber = ref.checkNumber;
        this.transaction = ref.transaction ? new Transaction(ref.transaction) : null;
        this.matchType = ref.matchType;
    }

    get importable() {
        return [
            'payhoa_deposit',
            'lockbox_deposit',
        ].indexOf(this.matchType) === -1 && !this.transaction;
    }

    get matched() {
        return this.transaction && this.matchType === 'transaction_date_amount';
    }
}
